import { authnClient } from '@frontend/auth';
import { http } from '@frontend/fetch';
import { resetAllStores } from '@frontend/store';
import { sentry } from '@frontend/tracking';

// signOut will end in a browser redirect away from the current page, the promise will never be resolved
// if you need side effects performed make sure to do them before calling this method
export const signOut = async () => {
  http.clearAllInterceptors();
  resetAllStores();

  // clear the user from Sentry so that any errors that occur after sign out will not be associated with the previously signed in user
  sentry.instance.setUser(null);

  // this results in a browser redirect
  await authnClient.signOut();
};
